import React, { useEffect, useState } from "react";
import { startCase } from "lodash";

import { P2 } from './DesignSystem/Text';
import colours from "./DesignSystem/Colours";

const findColourInName = (colourName) => {
    const style = new Option().style;
    const possibleColours = colourName.split(/\/| /);

    // get the first valid CSS colour from the colour name
    const foundColour = possibleColours.map(color => {
        style.color = color;
        return style.color !== '' ? color : null;
    }).filter(Boolean)[0];

    const isColourWhite = foundColour && foundColour.toLowerCase() === 'white';
    return isColourWhite ? '#F5F7F4' : foundColour;
}

export const VehicleColourBadge = ({ colourName = '', colourHex = '', colourCode = '' }) => {
    const [colour, setColor] = useState(colourHex);
    const parsedColourName = startCase(colourName?.toLowerCase());
    const colourNameWithCode = colourCode ? `${colourCode}: ${parsedColourName}` : parsedColourName;

    useEffect(() => {
        if (!colourHex && colourName) {
            const foundColour = findColourInName(colourName);
            setColor(foundColour);
        }
    }, [colourName, colourHex]);

    if (!colourName) return null;

    return !colour ? (
        <div
            className="vehicle-color-badge"
            style={{ border: `solid 1px ${colours.primary.grey02}`, backgroundColor: colours.primary.grey04, position: 'relative' }}
        >
            <P2 style={{ position: 'absolute', top: '5px', left: '9px', fontSize: 20, fontWeight: 700, color: colours.primary.grey02 }}>?</P2>
            <div className="vehicle-color-badge-text truncate">
                {colourNameWithCode}
            </div>
        </div>
    ) : (
        <div
            className="vehicle-color-badge"
            style={{ border: `solid 1px ${colours.primary.grey02}`, backgroundColor: colour, filter: !colourHex ? 'saturate(80%)' : '' }} // saturate the default CSS colour a bit
        >
            <div className="vehicle-color-badge-text truncate">
                {colourNameWithCode}
            </div>
        </div>
    )
};
